'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash.get');
const css = require('./personalizationStyle.scss');
const PersonalizationPanelItem = require('./PersonalizationPanelItem');
const PersonalizationPanelMainItem = require('./PersonalizationPanelMainItem');
const {getPersonalizationVariant} = require('../../helpers/tracking');

// TODO: Update how recommendation & trending data is handled GROWTH-1906
function normalizeTitle(personalizationData) {
    let categoryTitle = get(personalizationData, 'recommendable.properties.displayName') || get(personalizationData, 'recommendable.name') || personalizationData.displayName;
    const associatedCategory = get(personalizationData, 'associatedCategory.name');

    if (associatedCategory) {
        categoryTitle = `${categoryTitle} ${associatedCategory}`;
    }

    return categoryTitle;
}

function OtherItems({items, variant, categoryUrl}) {
    if (!items.length) {
        return null;
    }

    return (
        <div className={`colXs12 colXl6 ${css.flexItem}`}>
            <div className={`rowFlex ${css.smallItemListContainer}`}>
                {items.map((item, index) =>
                    <PersonalizationPanelItem
                        key={item.id}
                        item={item}
                        index={index + 1}
                        variant={variant}
                        categoryUrl={categoryUrl}
                    />
                )}
            </div>
        </div>
    );
}

OtherItems.propTypes = {
    items: PropTypes.array,
    variant: PropTypes.string,
    categoryUrl: PropTypes.string
};

function PersonalizationPanel(props) {
    const [item, ...otherItems] = props.item.items;
    const categoryTitle = normalizeTitle(props.item);
    const categoryUrl = props.item.url;
    const trackingVariant = getPersonalizationVariant(props.item);
    const mainItemProps = {
        isMobile: props.isMobile,
        variant: trackingVariant,
        item,
        categoryTitle,
        categoryUrl
    };

    if (!item) {
        return null;
    }

    return (
        <div className={`rowFlex ${css.itemPageContainer}`}>
            <PersonalizationPanelMainItem {...mainItemProps} />
            <OtherItems items={otherItems} variant={trackingVariant} categoryUrl={categoryUrl} />
        </div>
    );
}

PersonalizationPanel.propTypes = {
    item: PropTypes.object,
    isMobile: PropTypes.bool
};

module.exports = PersonalizationPanel;



// WEBPACK FOOTER //
// ./assets/js/home/components/personalization/PersonalizationPanel.jsx